import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import { AuthenticationMethodsEmailOTPSchema, EmailAuthenticationMethodConfigurationForm } from './model';

export function updateAuthenticationMethodsEmailOTPSchema(
    form: EmailAuthenticationMethodConfigurationForm,
): AuthenticationMethodsEmailOTPSchema {
    // If state is disabled, only return the state field
    if (form.state === 'disabled') {
        return {
            type: 'object',
            properties: {
                state: { type: 'string', const: form.state },
            },
        };
    }

    // If state is enabled, include all fields
    let includedTargetsOneOfItems: TargetSchemaItem[] = [];

    includedTargetsOneOfItems = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    return {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },
            allowExternalIdToUseEmailOtp: {
                type: 'string',
                const: form.allowExternalIdToUseEmailOtp,
            },
            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
        },
    };
}
